import ncTitle from "./ncTitle";
import ncTitleTwo from "./ncTitleTwo";
import ncTitleThree from "./ncTitleThree";

export default [ncTitle, ncTitleTwo, ncTitleThree];
